import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, parseVideo } from '../../lib/ep.js';

import VideoEmbed from '../front/VideoEmbed';

import BracketMosaic from '../front/BracketMosaic';
import LeveledHTMLText from '../front/helpers/LeveledHTMLText.js';

const Wrapper = (props) => {
	const is_builder = (props.is_builder != undefined) ? props.is_builder : false;

	if(!is_builder) {
		return (
			<div class="flex_cols">{props.children}</div>
		)
	}

	return (
		<div class="layout_conts">
			<div class="flex_cols">{props.children}</div>
		</div>
	)
};

function PromotionBracketsMosaic(props) {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const promo = (props.promo != undefined) ? props.promo : {};

	let main_image = false;
	let main_video = false;

	if(promo.brackets_mosaic_image != undefined && promo.brackets_mosaic_image != "") {
		main_image = promo.full_brackets_mosaic_image;
	} else if(promo.brackets_mosaic_video != undefined && promo.brackets_mosaic_video != "") {
		main_video = (promo.brackets_mosaic_video.url != undefined) ? promo.brackets_mosaic_video.url : parseVideo(promo.brackets_mosaic_video);
	}

	const default_description_text = '<h1>' + i18n("Brackets") + '</h1><p>' + i18n("Check the progress of the competition here.") + '</p>';
	const stages_description = (promo.brackets_mosaic_description != undefined && promo.brackets_mosaic_description != "") ? promo.brackets_mosaic_description : default_description_text;

	return (
		<Wrapper is_builder={props.is_builder}>
			{(main_image || main_video) && (
				<div class="flex_col col_1">
					<div class="main_media_flex">
						{(main_image) && (
							<img src={main_image} alt="" style={{maxWidth:'100%'}} />
						)}

						{(main_video) && (
							<VideoEmbed video_url={main_video.full_url} video_thumb={main_video.image}></VideoEmbed>
						)}
					</div>
				</div>
			)}

			<div class="flex_col col_2">
				{(stages_description != " ") && (
					<article class="promo_desc gui_main_text_color_on_bg main_text_flex">
						<LeveledHTMLText
							_class={{ other:'promotion_title' }}
						>{stages_description}</LeveledHTMLText>
					</article>
				)}

				<article class="promo_data template_module info_flexwrap gui_main_actions">
					{(props.brackets.length > 0) ? (
						<BracketMosaic in_mosaic={true} {...props} />
					) : (
						<div class="gui_main_text_color_on_bg gui_not_in_top_huge">{i18n("There's no participation stage available")}.</div>
					)}
				</article>
			</div>
		</Wrapper>
	);
}

export default injectIntl(PromotionBracketsMosaic);